// import { useState } from "react";
// import { toast } from "react-toastify";
// import { deleteTreeSpeciesApi } from "../../apis/treeSpeciesApi";

// export const useDeleteTreeSpecies = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const deleteTreeSpecies = async (id) => {
//     setLoading(true);
//     setError(null);

//     const toastId = toast.loading("Deleting tree species...");

//     try {
//       await deleteTreeSpeciesApi(id);

//       toast.update(toastId, {
//         render: "Tree species deleted successfully!",
//         type: "success",
//         isLoading: false,
//         autoClose: 3000,
//       });

//       return true;
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.detail ||
//         err.response?.data?.data ||
//         err.message ||
//         "Failed to delete tree species";

//       toast.update(toastId, {
//         render: errorMessage,
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });

//       setError(errorMessage);
//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   };

//   return { deleteTreeSpecies, loading, error };
// };


import { useState } from "react";
import { toast } from "react-toastify";
import { deleteTreeSpeciesApi } from "../../apis/treeSpeciesApi";

export const useDeleteTreeSpecies = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
   // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Failed to delete tree species.",
    };
  };

  const deleteTreeSpecies = async (id) => {
    setLoading(true);
    setError(null);

    const toastId = toast.loading("Deleting tree species...");

    try {
      await deleteTreeSpeciesApi(id);

      toast.update(toastId, {
        render: (
          <div>
            <strong>Tree Species Deleted</strong>
            <div>Tree species removed successfully.</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      return true;
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });

      setError({ title, issue });
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { deleteTreeSpecies, loading, error };
};